(function () {
  if (window.__LB_AI_CHATBOT_LOADED__) return;
  window.__LB_AI_CHATBOT_LOADED__ = true;

  var root = document.getElementById("lb-ai-chatbot");
  var configEl = document.getElementById("lb-ai-chatbot-config");

  if (!root || !configEl) return;

  var config = {};

  try {
    config = JSON.parse(configEl.textContent || "{}");
  } catch (error) {
    config = {};
  }

  var endpoint = root.getAttribute("data-endpoint");
  var storageKey = "lb_bonita_bot_state_v6";
  var sessionKey = "lb_bonita_bot_session_id";
  var conversationKey = "lb_bonita_bot_conversation_id";
  var customerKey = "lb_bonita_bot_customer";

  var mascotImage = config.mascotImage || "";
  var isHomePage = config.isHomePage === true;
  var pageData = config || {};

  var currentProductResults = [];
  var renderedProductCount = 0;
  var productsPerPage = 3;
  var lastUserMessage = "";

  function makeId(prefix) {
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function getSessionId() {
    try {
      var existing = localStorage.getItem(sessionKey);
      if (existing) return existing;

      var created = makeId("lb_session");
      localStorage.setItem(sessionKey, created);
      return created;
    } catch (error) {
      return makeId("lb_session");
    }
  }

  function getConversationId() {
    try {
      var existing = sessionStorage.getItem(conversationKey);
      if (existing) return existing;

      var created = makeId("lb_conversation");
      sessionStorage.setItem(conversationKey, created);
      return created;
    } catch (error) {
      return makeId("lb_conversation");
    }
  }

  var sessionId = getSessionId();
  var conversationId = getConversationId();

  function getCustomer() {
    try {
      var raw = localStorage.getItem(customerKey);
      if (!raw) return { name: "", email: "" };

      var parsed = JSON.parse(raw);

      return {
        name: parsed.name || "",
        email: parsed.email || ""
      };
    } catch (error) {
      return { name: "", email: "" };
    }
  }

  function setCustomer(name, email) {
    try {
      localStorage.setItem(customerKey, JSON.stringify({
        name: name || "",
        email: email || ""
      }));
    } catch (error) {}
  }

  function stripHtml(html) {
    var div = document.createElement("div");
    div.innerHTML = String(html || "");
    return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
  }

  function formatMoneyFromCents(cents) {
    var value = Number(cents || 0);
    if (!value) return "";
    return "NZ$" + (value / 100).toFixed(2);
  }

  function formatCatalogPrice(price) {
    if (price === null || price === undefined || price === "") return "";
    var clean = String(price).replace(/[^\d.]/g, "");
    if (!clean) return "";
    return "NZ$" + Number(clean).toFixed(2);
  }

  function getHandleFromUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^\/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      var fallback = String(url || "").match(/\/products\/([^\/?#]+)/);
      return fallback && fallback[1] ? decodeURIComponent(fallback[1]) : "";
    }
  }

  function buildPageContext(context) {
    var parts = [];

    parts.push("Current page type: " + (context.pageType || "unknown"));
    parts.push("Current page title: " + (context.pageTitle || "unknown"));

    if (context.product && context.product.title) {
      parts.push("Current product title: " + context.product.title);
      parts.push("Current product URL: " + window.location.origin + context.product.url);
      parts.push("Brand/vendor: " + (context.product.vendor || "unknown"));
      parts.push("Product type: " + (context.product.type || "unknown"));
      parts.push("Available on this page: " + (context.product.available ? "yes" : "no"));
      parts.push("Product tags: " + (context.product.tags || "none"));
      parts.push("Product description excerpt: " + (context.product.description || "not available"));
    }

    if (context.collection && context.collection.title) {
      parts.push("Collection title: " + context.collection.title);
      parts.push("Collection description excerpt: " + (context.collection.description || "not available"));
    }

    return parts.join("\n");
  }

  function isProductIntent(text) {
    return /recommend|suggest|product|cleanser|serum|ampoule|essence|toner|moisturi[sz]er|cream|sunscreen|spf|mask|oily|acne|pimple|pores|dry|hydration|sensitive|redness|bright|pigmentation|wrinkle|anti.?aging|anti.?ageing|routine|skin/i.test(String(text || ""));
  }

  function extractQueries(text) {
    var cleaned = String(text || "").toLowerCase();
    var queries = [];

    function add(query) {
      if (query && queries.indexOf(query) === -1) queries.push(query);
    }

    if (/sunscreen|spf|sun cream|sun-care|sun care/.test(cleaned)) {
      add("sunscreen");
      return queries;
    }

    if (/cleanser|wash|foam|gel/.test(cleaned) && /oily|oil|shine|acne|pimple|pores|breakout/.test(cleaned)) {
      add("salicylic cleanser");
      add("acne cleanser");
      add("oily skin cleanser");
      add("gel cleanser");
      add("foam cleanser");
    } else if (/cleanser|wash|foam|gel/.test(cleaned)) {
      add("cleanser");
      add("low ph cleanser");
      add("gentle cleanser");
    }

    if (/serum|ampoule|essence/.test(cleaned) && /oily|oil|acne|pimple|pores|breakout/.test(cleaned)) {
      add("niacinamide serum");
      add("acne serum");
      add("centella ampoule");
      add("tea tree serum");
      add("oily skin serum");
    } else if (/serum|ampoule|essence/.test(cleaned) && /hydration|hydrate|dehydrated|dry|moisture|hyaluronic/.test(cleaned)) {
      add("hyaluronic serum");
      add("hydrating serum");
      add("hyaluronic acid serum");
      add("ampoule");
    } else if (/serum|ampoule|essence/.test(cleaned)) {
      add("serum");
      add("ampoule");
      add("essence");
    }

    if (/sensitive|redness|irritat|barrier|fragrance|no fragrance/.test(cleaned)) {
      add("sensitive skin serum");
      add("centella serum");
      add("cica");
      add("fragrance free");
      add("heartleaf");
    }

    if (/dark spot|spots|pigmentation|bright|glow|dull/.test(cleaned)) {
      add("brightening serum");
      add("vitamin c");
      add("dark spot");
    }

    if (!queries.length) {
      add(cleaned.replace(/[^\w\s-]/g, " ").replace(/\s+/g, " ").trim().slice(0, 80));
    }

    return queries.slice(0, 6);
  }

  function productSearchText(product) {
    return [
      product.title,
      product.vendor,
      product.type,
      Array.isArray(product.tags) ? product.tags.join(" ") : product.tags,
      product.description
    ].join(" ").toLowerCase();
  }

  function rankProduct(product, message) {
    var msg = String(message || "").toLowerCase();
    var text = productSearchText(product);
    var score = 0;

    if (/sunscreen|spf|sun cream/.test(msg)) score -= 999;

    if (/cleanser|wash|foam|gel/.test(msg) && /cleanser|foam|gel cleanser|facial wash|wash/.test(text)) score += 18;
    if (/serum|ampoule|essence/.test(msg) && /serum|ampoule|essence/.test(text)) score += 18;
    if (/moisturi[sz]er|cream/.test(msg) && /moisturi|cream|gel cream|lotion/.test(text)) score += 16;
    if (/toner/.test(msg) && /toner/.test(text)) score += 14;

    if (/oily|oil|shine|pores/.test(msg) && /oily|oil|sebum|pore|pores|shine|mattifying|niacinamide|tea tree|bha|salicylic/.test(text)) score += 10;
    if (/acne|pimple|breakout|blemish/.test(msg) && /acne|pimple|blemish|breakout|salicylic|bha|tea tree|centella|cica|spot|succinic/.test(text)) score += 10;
    if (/hydration|hydrate|dehydrated|moisture|hyaluronic/.test(msg) && /hydrating|hydration|hyaluronic|moisture|moisturising|moisturizing|panthenol|betaine/.test(text)) score += 10;
    if (/sensitive|redness|irritat|barrier|fragrance|no fragrance/.test(msg) && /sensitive|calming|soothing|centella|cica|heartleaf|madecassoside|barrier|panthenol|fragrance.?free/.test(text)) score += 10;
    if (/bright|pigmentation|dark spot|dull|glow/.test(msg) && /bright|glow|vitamin c|niacinamide|dark spot|pigmentation|arbutin/.test(text)) score += 8;

    if (product.available === true) score += 3;
    if (product.image) score += 1;

    return score;
  }

  function dedupeProducts(products) {
    var seen = {};
    var output = [];

    products.forEach(function (product) {
      var key = product.handle || product.url || product.title;
      if (!key || seen[key]) return;

      seen[key] = true;
      output.push(product);
    });

    return output;
  }

  function sortProducts(products, message) {
    return products
      .map(function (product) {
        product._score = rankProduct(product, message);
        return product;
      })
      .sort(function (a, b) {
        return b._score - a._score;
      });
  }

  function makeBenefit(product, message) {
    var msg = String(message || "").toLowerCase();
    var title = String(product.title || "").toLowerCase();
    var description = String(product.description || "").replace(/\s+/g, " ").trim();

    if (/cleanser|wash|foam|gel/.test(msg)) {
      if (/salicylic|bha|acne|pore|succinic/.test(title + " " + description.toLowerCase())) {
        return "Good for oily or breakout-prone skin when you want a clearer, fresher cleanse.";
      }

      return "A cleansing option to help refresh the skin without feeling too heavy.";
    }

    if (/serum|ampoule|essence/.test(msg)) {
      if (/niacinamide|pore|sebum/.test(title + " " + description.toLowerCase())) {
        return "A lightweight option for oily skin, pores and uneven-looking tone.";
      }

      if (/centella|cica|heartleaf|calming/.test(title + " " + description.toLowerCase())) {
        return "A calming option for skin that feels reactive, oily or easily stressed.";
      }

      if (/hyaluronic|hydrating|moisture/.test(title + " " + description.toLowerCase())) {
        return "A light hydrating option that layers well without a heavy finish.";
      }
    }

    if (description) {
      return description.slice(0, 115) + (description.length > 115 ? "..." : "");
    }

    return "A matching option from Lady Bonita based on your request.";
  }

  async function fetchProductDetails(handle, fallback) {
    try {
      var response = await fetch("/products/" + encodeURIComponent(handle) + ".js", {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) return fallback;

      var product = await response.json();
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.find(function (item) { return item.available; }) || variants[0] || {};

      return {
        id: product.id || fallback.id || "",
        title: product.title || fallback.title || "",
        vendor: product.vendor || fallback.vendor || "",
        type: product.type || fallback.type || "",
        handle: product.handle || handle,
        url: window.location.origin + "/products/" + (product.handle || handle),
        image: product.featured_image || (product.images && product.images[0]) || fallback.image || "",
        priceText: formatMoneyFromCents(product.price || variant.price),
        variantId: variant.id || fallback.variantId || "",
        available: product.available === true || variant.available === true,
        tags: product.tags || "",
        description: stripHtml(product.description || fallback.description || "").slice(0, 800)
      };
    } catch (error) {
      return fallback;
    }
  }

  async function searchPredictiveProducts(message) {
    var queries = extractQueries(message);
    var baseProducts = [];
    var seenHandles = {};

    for (var i = 0; i < queries.length; i++) {
      try {
        var query = queries[i];
        var url = "/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";

        var response = await fetch(url, {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        });

        if (!response.ok) continue;

        var data = await response.json();
        var products = data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
            ? data.resources.results.products
            : [];

        products.forEach(function (product) {
          var productUrl = product.url || "";
          var handle = getHandleFromUrl(productUrl);

          if (!handle || seenHandles[handle]) return;

          seenHandles[handle] = true;

          baseProducts.push({
            id: product.id || "",
            title: product.title || "",
            vendor: product.vendor || "",
            type: product.type || "",
            handle: handle,
            url: window.location.origin + "/products/" + handle,
            image: product.featured_image && product.featured_image.url ? product.featured_image.url : "",
            priceText: product.price || "",
            variantId: "",
            available: product.available,
            tags: "",
            description: stripHtml(product.body || product.description || "").slice(0, 600)
          });
        });
      } catch (error) {}
    }

    var detailed = await Promise.all(
      baseProducts.slice(0, 16).map(function (product) {
        return fetchProductDetails(product.handle, product);
      })
    );

    return detailed;
  }

  async function loadCatalogProducts() {
    var cacheKey = "lb_ai_catalog_products_v6";
    var cacheMaxAge = 15 * 60 * 1000;

    try {
      var cached = sessionStorage.getItem(cacheKey);

      if (cached) {
        var parsed = JSON.parse(cached);

        if (parsed && parsed.time && parsed.products && Date.now() - parsed.time < cacheMaxAge) {
          return parsed.products;
        }
      }
    } catch (error) {}

    try {
      var response = await fetch("/products.json?limit=250", {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) return [];

      var data = await response.json();
      var products = Array.isArray(data.products) ? data.products : [];

      var compact = products.map(function (product) {
        var variants = Array.isArray(product.variants) ? product.variants : [];
        var variant = variants.find(function (item) { return item.available; }) || variants[0] || {};
        var firstImage = product.images && product.images[0] ? product.images[0] : {};
        var image = firstImage.src || firstImage || "";

        return {
          id: product.id || "",
          title: product.title || "",
          vendor: product.vendor || "",
          type: product.product_type || product.type || "",
          handle: product.handle || "",
          url: window.location.origin + "/products/" + product.handle,
          image: image,
          priceText: formatCatalogPrice(variant.price),
          variantId: variant.id || "",
          available: variant.available === true,
          tags: product.tags || "",
          description: stripHtml(product.body_html || product.description || "").slice(0, 800)
        };
      }).filter(function (product) {
        return product.title && product.handle;
      });

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({
          time: Date.now(),
          products: compact
        }));
      } catch (error) {}

      return compact;
    } catch (error) {
      return [];
    }
  }

  async function searchShopifyProducts(message) {
    if (!isProductIntent(message)) return [];

    if (/sunscreen|spf|sun cream|sun-care|sun care/i.test(String(message || ""))) {
      return [];
    }

    var predictiveProducts = await searchPredictiveProducts(message);
    var catalogProducts = await loadCatalogProducts();

    var rankedCatalog = sortProducts(catalogProducts, message).filter(function (product) {
      return product._score > 0;
    });

    var merged = predictiveProducts.concat(rankedCatalog.slice(0, 20));

    var finalProducts = sortProducts(dedupeProducts(merged), message)
      .filter(function (product) {
        return product._score > 0;
      })
      .slice(0, 12)
      .map(function (product) {
        product.benefit = makeBenefit(product, message);
        return product;
      });

    return finalProducts;
  }

  function buildProductContext(products) {
    var parts = [];

    if (pageData.product && pageData.product.title) {
      parts.push("Current product on page:");
      parts.push("- " + pageData.product.title + " | " + window.location.origin + pageData.product.url);
      parts.push("  Brand: " + (pageData.product.vendor || "unknown"));
      parts.push("  Product type: " + (pageData.product.type || "unknown"));
      parts.push("  Available on this page: " + (pageData.product.available ? "yes" : "no"));
      parts.push("  Tags: " + (pageData.product.tags || "none"));
      parts.push("  Description: " + (pageData.product.description || "not available"));
    }

    if (products && products.length) {
      parts.push("Live products found from Lady Bonita storefront search. Product cards will be shown below the message, so do not paste URLs in the answer:");

      products.slice(0, 6).forEach(function (product, index) {
        parts.push(
          (index + 1) + ". " +
          product.title +
          " | Brand: " + (product.vendor || "unknown") +
          " | Type: " + (product.type || "unknown") +
          " | URL: " + product.url +
          " | Price: " + (product.priceText || "check product page") +
          " | Availability: " + (product.available ? "available" : "sold out or unavailable") +
          " | Benefit shown on card: " + (product.benefit || "") +
          " | Tags: " + (Array.isArray(product.tags) ? product.tags.join(", ") : product.tags || "not shown") +
          " | Description: " + String(product.description || "").replace(/\s+/g, " ").slice(0, 350)
        );
      });
    }

    if (!parts.length) {
      parts.push("No exact product candidates were found from the live storefront search.");
    }

    return parts.join("\n");
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function linkify(text) {
    var safe = escapeHtml(text);

    return safe.replace(/(https:\/\/ladybonita\.co\.nz\/[^\s]+)/g, function (url) {
      return '<a href="' + url + '" target="_self" rel="noopener noreferrer">' + url + '</a>';
    });
  }

  function scrollToElementStart(element) {
    if (!element) return;

    setTimeout(function () {
      var messageRect = element.getBoundingClientRect();
      var containerRect = messages.getBoundingClientRect();
      var top = messageRect.top - containerRect.top + messages.scrollTop;
      messages.scrollTop = Math.max(0, top - 8);
    }, 30);
  }

  function saveState() {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        html: messages ? messages.innerHTML : "",
        isOpen: root.classList.contains("is-open"),
        currentProductResults: currentProductResults,
        renderedProductCount: renderedProductCount,
        lastUserMessage: lastUserMessage,
        timestamp: Date.now()
      }));
    } catch (error) {}
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(storageKey);
      if (!raw) return false;

      var state = JSON.parse(raw);
      if (!state || !state.html) return false;

      if (Date.now() - Number(state.timestamp || 0) > 60 * 60 * 1000) {
        sessionStorage.removeItem(storageKey);
        return false;
      }

      messages.innerHTML = state.html;
      currentProductResults = Array.isArray(state.currentProductResults) ? state.currentProductResults : [];
      renderedProductCount = Number(state.renderedProductCount || 0);
      lastUserMessage = state.lastUserMessage || "";

      if (state.isOpen) {
        root.classList.add("is-open");
      }

      setTimeout(function () {
        initWishlistEngine();
      }, 700);

      return true;
    } catch (error) {
      return false;
    }
  }

  async function trackEvent(eventType, payload) {
    var customer = getCustomer();

    try {
      await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(Object.assign({
          mode: "analytics",
          eventType: eventType,
          sessionId: sessionId,
          conversationId: conversationId,
          customerName: customer.name,
          customerEmail: customer.email,
          pageUrl: window.location.href,
          pageTitle: document.title
        }, payload || {}))
      });
    } catch (error) {}
  }

  function initWishlistEngine() {
    try {
      document.dispatchEvent(new CustomEvent("wishlist-engine:refresh"));
      window.dispatchEvent(new CustomEvent("wishlist-engine:refresh"));
    } catch (error) {}

    try {
      if (window.WishlistEngine && typeof window.WishlistEngine.init === "function") {
        window.WishlistEngine.init();
      }
    } catch (error) {}

    try {
      if (window.wishlistEngine && typeof window.wishlistEngine.init === "function") {
        window.wishlistEngine.init();
      }
    } catch (error) {}

    try {
      if (window.SEWishlist && typeof window.SEWishlist.init === "function") {
        window.SEWishlist.init();
      }
    } catch (error) {}

    try {
      if (window.SEWishlistEngine && typeof window.SEWishlistEngine.init === "function") {
        window.SEWishlistEngine.init();
      }
    } catch (error) {}
  }

  var pageContext = buildPageContext(pageData);

  root.className = "lb-ai-chatbot";

  root.innerHTML =
    '<button type="button" class="lb-ai-chatbot__button" aria-label="Open Bonita Bot">' +
      '<img class="lb-ai-chatbot__button-image" src="' + mascotImage + '" alt="Bonita Bot" onerror="this.style.display=\'none\'; this.nextElementSibling.style.display=\'block\';">' +
      '<span class="lb-ai-chatbot__button-fallback">Bonita<br>Bot</span>' +
    '</button>' +
    (isHomePage ? '<div class="lb-ai-chatbot__home-tip">Ask Bonita Bot for personalised product help.</div>' : '') +
    '<div class="lb-ai-chatbot__panel" role="dialog" aria-label="Bonita Bot">' +
      '<div class="lb-ai-chatbot__header">' +
        '<div class="lb-ai-chatbot__header-content">' +
          '<p class="lb-ai-chatbot__title">Bonita Bot</p>' +
          '<p class="lb-ai-chatbot__subtitle">Product help, pre-orders and NZ shipping.</p>' +
        '</div>' +
        '<button type="button" class="lb-ai-chatbot__close" aria-label="Close chat">×</button>' +
      '</div>' +
      '<div class="lb-ai-chatbot__messages" aria-live="polite"></div>' +
      '<div class="lb-ai-chatbot__quick">' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-question="Recommend a cleanser for oily acne-prone skin.">Oily cleanser</button>' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-question="I need a serum for oily skin.">Oily serum</button>' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-question="I need a gentle product for sensitive skin.">Sensitive skin</button>' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-question="What should I use for hydration?">Hydration</button>' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-question="How long does pre-order take?">Pre-order</button>' +
        '<button type="button" class="lb-ai-chatbot__quick-button" data-action="open-help">Need personalised help?</button>' +
      '</div>' +
      '<form class="lb-ai-chatbot__form">' +
        '<input class="lb-ai-chatbot__input" type="text" maxlength="600" placeholder="Ask Bonita Bot..." autocomplete="off">' +
        '<button class="lb-ai-chatbot__send" type="submit">Send</button>' +
      '</form>' +
      '<div class="lb-ai-chatbot__note">General guidance only. Not clinical advice. Product information may be updated by the manufacturer, so please check the product packaging for the latest instructions and ingredients. Patch test on a small area before use.</div>' +
    '</div>';

  var openButton = root.querySelector(".lb-ai-chatbot__button");
  var closeButton = root.querySelector(".lb-ai-chatbot__close");
  var messages = root.querySelector(".lb-ai-chatbot__messages");
  var form = root.querySelector(".lb-ai-chatbot__form");
  var input = root.querySelector(".lb-ai-chatbot__input");
  var sendButton = root.querySelector(".lb-ai-chatbot__send");
  var quickButtons = root.querySelectorAll(".lb-ai-chatbot__quick-button");

  function appendMessage(role, text) {
    var message = document.createElement("div");
    message.className = "lb-ai-chatbot__message lb-ai-chatbot__message--" + role;

    if (role === "bot") {
      message.innerHTML = linkify(text);
    } else {
      message.textContent = text;
    }

    messages.appendChild(message);
    saveState();

    return message;
  }

  function renderFeedbackBlock() {
    var wrapper = document.createElement("div");
    wrapper.className = "lb-ai-chatbot__feedback";
    wrapper.innerHTML =
      '<p class="lb-ai-chatbot__feedback-title">Rate this help</p>' +
      '<div class="lb-ai-chatbot__feedback-actions">' +
        '<button type="button" data-feedback="good">Good</button>' +
        '<button type="button" data-feedback="not_quite">Not quite</button>' +
        '<button type="button" data-feedback="comment">Leave feedback</button>' +
      '</div>' +
      '<div class="lb-ai-chatbot__feedback-form">' +
        '<textarea class="lb-ai-chatbot__textarea" maxlength="800" placeholder="Tell us what Bonita Bot could improve..."></textarea>' +
        '<button type="button" class="lb-ai-chatbot__secondary-action" data-feedback-submit="true">Send feedback</button>' +
      '</div>';

    messages.appendChild(wrapper);
    saveState();

    return wrapper;
  }

  function renderHelpPanel() {
    var existing = messages.querySelector(".lb-ai-chatbot__help-panel.is-open");

    if (existing) {
      scrollToElementStart(existing);
      return existing;
    }

    var customer = getCustomer();

    var panel = document.createElement("div");
    panel.className = "lb-ai-chatbot__help-panel is-open";
    panel.innerHTML =
      '<p class="lb-ai-chatbot__help-title">Need personalised help?</p>' +
      '<p class="lb-ai-chatbot__help-copy">Leave your name, email, order number if relevant, and your message. Our team will check it and reply as soon as possible.</p>' +
      '<div class="lb-ai-chatbot__help-grid">' +
        '<input class="lb-ai-chatbot__help-input" data-help-name type="text" maxlength="120" placeholder="Name" value="' + escapeHtml(customer.name || "") + '">' +
        '<input class="lb-ai-chatbot__help-input" data-help-email type="email" maxlength="180" placeholder="Email address" value="' + escapeHtml(customer.email || "") + '">' +
        '<input class="lb-ai-chatbot__help-input" data-help-order type="text" maxlength="80" placeholder="Order number, if relevant">' +
        '<textarea class="lb-ai-chatbot__help-textarea" data-help-message maxlength="1200" placeholder="How can our team help?"></textarea>' +
        '<button type="button" class="lb-ai-chatbot__help-submit" data-help-submit="true">Send to Lady Bonita team</button>' +
      '</div>';

    messages.appendChild(panel);
    scrollToElementStart(panel);
    saveState();

    trackEvent("help_form_opened", {
      message: lastUserMessage,
      productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
        return {
          title: product.title,
          url: product.url,
          available: product.available
        };
      })
    });

    return panel;
  }

  function renderProductCards(products, reset) {
    if (!products || !products.length) return null;

    if (reset) {
      currentProductResults = products;
      renderedProductCount = 0;
    }

    var slice = currentProductResults.slice(renderedProductCount, renderedProductCount + productsPerPage);
    if (!slice.length) return null;

    var wrapper = document.createElement("div");
    wrapper.className = "lb-ai-chatbot__products";

    slice.forEach(function (product) {
      var card = document.createElement("div");
      card.className = "lb-ai-chatbot__product-card";

      var imageHtml = product.image
        ? '<img class="lb-ai-chatbot__product-image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">'
        : '<div class="lb-ai-chatbot__product-image" aria-hidden="true"></div>';

      var statusHtml = product.available
        ? ''
        : '<span class="lb-ai-chatbot__product-status">Sold out</span>';

      var actionHtml = product.available && product.variantId
        ? '<button type="button" class="lb-ai-chatbot__add" data-variant-id="' + escapeHtml(product.variantId) + '">Add to cart</button>'
        : '<a class="lb-ai-chatbot__add" href="' + escapeHtml(product.url) + '">Notify me</a>';

      var wishlistHtml = "";

      if (product.id && product.variantId) {
        wishlistHtml =
          '<span class="lb-ai-chatbot__wishlist-wrap" title="Add to wishlist">' +
            '<div class="wishlist-engine" data-product_id="' + escapeHtml(product.id) + '" data-variant_id="' + escapeHtml(product.variantId) + '" data-full_button="false" data-css="true"></div>' +
          '</span>';
      } else {
        wishlistHtml =
          '<button type="button" class="lb-ai-chatbot__wishlist-fallback" data-local-wishlist="' + escapeHtml(product.handle || product.url || product.title) + '" title="Save for later">♡</button>';
      }

      card.innerHTML =
        imageHtml +
        '<div>' +
          '<a class="lb-ai-chatbot__product-title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<p class="lb-ai-chatbot__product-meta">' +
            escapeHtml(product.vendor || "Lady Bonita") +
            (product.priceText ? " · " + escapeHtml(product.priceText) : "") +
            statusHtml +
          '</p>' +
          '<p class="lb-ai-chatbot__product-benefit">' + escapeHtml(product.benefit || "A matching option from Lady Bonita based on your request.") + '</p>' +
          '<div class="lb-ai-chatbot__product-actions">' +
            '<a class="lb-ai-chatbot__view" href="' + escapeHtml(product.url) + '">View</a>' +
            actionHtml +
            wishlistHtml +
            '<a class="lb-ai-chatbot__cart-link" href="/cart">View cart</a>' +
          '</div>' +
        '</div>';

      wrapper.appendChild(card);
    });

    renderedProductCount += slice.length;

    if (renderedProductCount < currentProductResults.length) {
      var moreButton = document.createElement("button");
      moreButton.type = "button";
      moreButton.className = "lb-ai-chatbot__more";
      moreButton.textContent = "Show more";
      moreButton.setAttribute("data-show-more", "true");
      wrapper.appendChild(moreButton);
    }

    messages.appendChild(wrapper);

    setTimeout(function () {
      initWishlistEngine();
    }, 700);

    saveState();

    return wrapper;
  }

  function setLoading(isLoading) {
    sendButton.disabled = isLoading;
    input.disabled = isLoading;
    sendButton.textContent = isLoading ? "..." : "Send";
  }

  async function addToCart(button) {
    var variantId = button.getAttribute("data-variant-id");
    if (!variantId) return;

    button.disabled = true;
    button.textContent = "Adding...";

    try {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) {
        button.textContent = "Try again";
        button.disabled = false;
        return;
      }

      var card = button.closest(".lb-ai-chatbot__product-card");
      if (card) card.classList.add("is-added");

      button.textContent = "Added ✓";
      button.disabled = true;

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));

      trackEvent("add_to_cart", {
        message: lastUserMessage,
        productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
          return {
            title: product.title,
            url: product.url,
            available: product.available
          };
        })
      });

      saveState();
    } catch (error) {
      button.textContent = "Try again";
      button.disabled = false;
    }
  }

  async function submitHelpRequest(panel) {
    var nameInput = panel.querySelector("[data-help-name]");
    var emailInput = panel.querySelector("[data-help-email]");
    var orderInput = panel.querySelector("[data-help-order]");
    var messageInput = panel.querySelector("[data-help-message]");
    var button = panel.querySelector("[data-help-submit]");

    var name = nameInput ? nameInput.value.trim() : "";
    var email = emailInput ? emailInput.value.trim() : "";
    var orderNumber = orderInput ? orderInput.value.trim() : "";
    var message = messageInput ? messageInput.value.trim() : "";

    if (!name || !email || !message) {
      appendMessage("bot", "Please add your name, email and message so our team can reply properly.");
      scrollToElementStart(panel);
      return;
    }

    setCustomer(name, email);

    button.disabled = true;
    button.textContent = "Sending...";

    try {
      var response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mode: "analytics",
          eventType: "help_request",
          sessionId: sessionId,
          conversationId: conversationId,
          customerName: name,
          name: name,
          customerEmail: email,
          orderNumber: orderNumber,
          message: message,
          pageUrl: window.location.href,
          pageTitle: document.title,
          productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
            return {
              title: product.title,
              url: product.url,
              available: product.available
            };
          })
        })
      });

      var data = await response.json();

      if (!response.ok || !data.ok) {
        button.disabled = false;
        button.textContent = "Send to Lady Bonita team";
        appendMessage("bot", "Sorry, I couldn’t send that just now. Please try again shortly or contact us through the website.");
        return;
      }

      panel.classList.remove("is-open");
      appendMessage("bot", "Thanks — your message has been sent to the Lady Bonita team. They’ll check it and reply as soon as possible.");
      saveState();
    } catch (error) {
      button.disabled = false;
      button.textContent = "Send to Lady Bonita team";
      appendMessage("bot", "Sorry, I couldn’t send that just now. Please try again shortly or contact us through the website.");
    }
  }

  async function submitFeedback(button) {
    var wrapper = button.closest(".lb-ai-chatbot__feedback");
    if (!wrapper) return;

    var textarea = wrapper.querySelector(".lb-ai-chatbot__textarea");
    var feedbackText = textarea ? textarea.value.trim() : "";

    if (!feedbackText) {
      wrapper.classList.add("is-open");
      return;
    }

    button.disabled = true;
    button.textContent = "Sending...";

    await trackEvent("feedback", {
      feedback: feedbackText,
      message: lastUserMessage,
      productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
        return {
          title: product.title,
          url: product.url,
          available: product.available
        };
      })
    });

    button.textContent = "Sent ✓";

    appendMessage("bot", "Thank you — that helps Bonita Bot improve.");
    saveState();
  }

  async function sendMessage(text) {
    var cleanText = String(text || "").trim();
    if (!cleanText) return;

    lastUserMessage = cleanText;

    var turnStart = appendMessage("user", cleanText);
    input.value = "";
    setLoading(true);
    scrollToElementStart(turnStart);

    try {
      var products = await searchShopifyProducts(cleanText);
      var productContext = buildProductContext(products);
      var customer = getCustomer();

      trackEvent("question", {
        message: cleanText,
        productsShown: products.slice(0, 6).map(function (product) {
          return {
            title: product.title,
            url: product.url,
            available: product.available
          };
        })
      });

      var response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          mode: "chatbot",
          sessionId: sessionId,
          conversationId: conversationId,
          customerName: customer.name,
          customerEmail: customer.email,
          message: cleanText,
          pageContext: pageContext,
          productContext: productContext,
          pageUrl: window.location.href,
          pageTitle: document.title,
          productsShown: products.slice(0, 6).map(function (product) {
            return {
              title: product.title,
              url: product.url,
              available: product.available
            };
          })
        })
      });

      var data = await response.json();

      if (!response.ok) {
        appendMessage("bot", "Sorry, Bonita Bot could not process that just now. You can use Need personalised help and our team can check it for you.");
        renderHelpPanel();
        setLoading(false);
        scrollToElementStart(turnStart);
        return;
      }

      appendMessage("bot", data.answer || "Sorry, Bonita Bot could not generate a response.");

      if (products && products.length) {
        renderProductCards(products, true);
      }

      renderFeedbackBlock();

      if (/human|person|staff|advisor|help|order|tracking|refund|return|payment|address|urgent/i.test(cleanText)) {
        renderHelpPanel();
      }

      scrollToElementStart(turnStart);
    } catch (error) {
      appendMessage("bot", "Sorry, Bonita Bot is not available right now. You can use Need personalised help and our team can help.");
      renderHelpPanel();
      scrollToElementStart(turnStart);
    }

    setLoading(false);
    input.focus();
    saveState();
  }

  openButton.addEventListener("click", function () {
    root.classList.add("is-open");

    if (!messages.dataset.started && !messages.innerHTML.trim()) {
      appendMessage("bot", "Hi, I’m Bonita Bot. I can help with product recommendations, pre-orders and NZ shipping.");
      messages.dataset.started = "true";
    }

    trackEvent("chat_opened", {
      message: "",
      productsShown: []
    });

    setTimeout(function () {
      input.focus();
      messages.scrollTop = messages.scrollHeight;
    }, 100);

    saveState();
  });

  closeButton.addEventListener("click", function () {
    root.classList.remove("is-open");
    saveState();
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    sendMessage(input.value);
  });

  quickButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var action = button.getAttribute("data-action");

      if (action === "open-help") {
        root.classList.add("is-open");
        renderHelpPanel();
        saveState();
        return;
      }

      sendMessage(button.getAttribute("data-question"));
    });
  });

  root.addEventListener("click", function (event) {
    var addButton = event.target.closest(".lb-ai-chatbot__add[data-variant-id]");
    if (addButton) {
      addToCart(addButton);
      return;
    }

    var moreButton = event.target.closest("[data-show-more]");
    if (moreButton) {
      moreButton.remove();
      var wrapper = renderProductCards(currentProductResults, false);
      if (wrapper) scrollToElementStart(wrapper);

      trackEvent("show_more_products", {
        message: lastUserMessage,
        productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
          return {
            title: product.title,
            url: product.url,
            available: product.available
          };
        })
      });

      return;
    }

    var localWishlistButton = event.target.closest("[data-local-wishlist]");
    if (localWishlistButton) {
      localWishlistButton.classList.toggle("is-selected");
      localWishlistButton.textContent = localWishlistButton.classList.contains("is-selected") ? "♥" : "♡";

      trackEvent("local_wishlist_click", {
        message: lastUserMessage,
        productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
          return {
            title: product.title,
            url: product.url,
            available: product.available
          };
        })
      });

      saveState();
      return;
    }

    var helpSubmit = event.target.closest("[data-help-submit]");
    if (helpSubmit) {
      var panel = helpSubmit.closest(".lb-ai-chatbot__help-panel");
      if (panel) submitHelpRequest(panel);
      return;
    }

    var feedbackButton = event.target.closest("[data-feedback]");
    if (feedbackButton) {
      var feedbackWrap = feedbackButton.closest(".lb-ai-chatbot__feedback");
      var feedbackType = feedbackButton.getAttribute("data-feedback");

      if (!feedbackWrap) return;

      feedbackWrap.querySelectorAll("[data-feedback]").forEach(function (btn) {
        btn.classList.remove("is-selected");
      });

      feedbackButton.classList.add("is-selected");

      if (feedbackType === "comment" || feedbackType === "not_quite") {
        feedbackWrap.classList.add("is-open");
      }

      if (feedbackType === "good") {
        trackEvent("feedback", {
          feedback: "good",
          message: lastUserMessage,
          productsShown: currentProductResults.slice(0, renderedProductCount).map(function (product) {
            return {
              title: product.title,
              url: product.url,
              available: product.available
            };
          })
        });

        appendMessage("bot", "Thank you — glad that helped.");
      }

      saveState();
      return;
    }

    var feedbackSubmit = event.target.closest("[data-feedback-submit]");
    if (feedbackSubmit) {
      submitFeedback(feedbackSubmit);
      return;
    }
  });

  restoreState();
})();